import dedent from 'ts-dedent'
import {
  ColumnDataType,
  GetOutputSchemaParams,
  Provider,
  TableSchema,
  WorkflowComponentCodeParams,
  WorkflowComponentParamType
} from '../types'
import { addColumn } from '../utils/schemas'
import { SelectWorkflowComponent } from './common/selectcomponent'

class NumGeometries extends SelectWorkflowComponent {
  constructor() {
    super(
      {
        name: 'native.numgeometries',
        group: 'Spatial Accessors',
        title: 'ST NumGeometries',
        description: `
      This component creates a new table with an additional column with the number of
      parts in each input geography.
      `
      },
      [
        {
          name: 'source',
          type: WorkflowComponentParamType.InputTable,
          title: 'Source table'
        },
        {
          name: 'geo',
          type: WorkflowComponentParamType.Column,
          title: 'Geo column',
          parent: 'source',
          dataType: [ColumnDataType.Geography, ColumnDataType.Geometry]
        }
      ]
    )
  }

  getInnerSql({ params, connection }: WorkflowComponentCodeParams) {
    switch (connection.type) {
      case Provider.BigQuery:
      case Provider.Postgres:
      case Provider.Redshift:
        return dedent`SELECT *, ST_NUMGEOMETRIES(${params.geo})
                  AS ${params.geo}_ngeoms
                FROM ${connection.quoteName(params.source as string)}`
      case Provider.DatabricksRest:
        return dedent`SELECT /*+ REPARTITION(40) */
                  *, ST_NUMGEOMETRIES(${connection.processInputGeogColumn(params.geo as string)})
                  AS ${params.geo}_ngeoms
                FROM ${connection.quoteName(params.source as string)}`
      case Provider.Oracle:
        return dedent`SELECT t.*,
        SDO_UTIL.GETNUMELEM(t.${params.geo}) AS ${params.geo}_ngeoms
        FROM ${connection.quoteName(params.source as string)} t`
      default:
        return null
    }
  }

  canProvideOutputSchemas(): boolean {
    return true
  }

  getOutputSchema({ columns, params }: GetOutputSchemaParams): TableSchema {
    return addColumn(columns.source, {
      name: `${params.geo}_ngeoms`,
      type: ColumnDataType.Number
    })
  }
  supportedProviders(): Provider[] {
    return [Provider.BigQuery, Provider.Postgres, Provider.Redshift, Provider.DatabricksRest, Provider.Oracle]
  }
}

export { NumGeometries }
